// @flow
import styled, { keyframes } from 'styled-components';
import {
  ml, px, py, p
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import { SvgChevronRight } from '@images/svg';
import { linkButtonIcon } from '@styles/links';
import theme from '@theme';
import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';

const { colors } = theme;

const shake = keyframes`
  10% {
    transform: translate3d(0px, 0, 0);
  }
 
  100% {
    transform: translate3d(6px, 0, 0);
  }
`;


export const StyledLink = styled.a`
  display: flex;
  flex-direction: column;
  ${linkButtonIcon}
  padding: 0.7rem;
  margin-top: 12px;
  margin-bottom: 12px;
  color: ${colors.navyGray} !important;
  top: 25px;
  font-style: normal;

  /* &:hover{
    animation: ${shake} 0.5s cubic-bezier(.36,.07,.19,.97) both;
    // transform: translate3d(0, 0, 0); 
    perspective: 1000px;
  } */
  
  ${breakpoint('desktop')`
    font-size: 24px;
    color: ${colors.navyGray} !important;
 `}
  ${breakpoint('mobile', 'tablet')`
    font-style: normal;
    font-weight: 50px;
    font-size: 15px;
    line-height: 20px;
    color: ${colors.white} !important;
    border-radius: 2px; 
    border-left: none;
    background: transparent;
    border-right: none;
    border-top: none;
    border-bottom: 2px solid white;
    box-shadow: none;
    margin: 0rem;
   @media only screen and (max-width: 360px) {
  {
   width: auto;
   font-weight: 50px;
   font-size: 13px;
   line-height: 15px;

  }

  
  }
  ${breakpoint('tablet')`
    font-size: 13px;
    color: ${colors.navyGray} !important;
  `}
  
 `};
`;

export const StyledIcon = styled(SvgChevronRight)`
  ${ml(3)}
  height: 16px;
  width: 16px;

  ${breakpoint('mobile', 'tablet')`
    display: none;`}
  g {
    fill: ${theme.colors.turquoise};
  }
  flex: 0 0 auto;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: -webkit-fill-available;
  ${px(3)}
  ${py(0)}
  border-radius: 8px;
  ${breakpoint('mobile', 'tablet')`
     ${p(0)}
  `}
`;

export const StyledQuestion = styled.div`
  color: #3a3a3a;
  font-size: 22px;
  padding: 10px 0;
  font-weight: 700;
  ${breakpoint('mobile', 'tablet')`
    font-size: 20px;
    line-height: 1.4;
    color:rgb(255, 255, 255);
  `}
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  svg,
  path {
    width: 20px;
    height: 20px;
    fill: #3a3a3a;
    transform-origin: center;
    transform: ${props => (props.active ? 'rotate(90deg)' : '')};
    transition: all 500ms ease-in-out 0s;
    ${breakpoint('mobile', 'tablet')`
      fill: white;
   `}
  }
`;

export const StyledAnswer = styled.div`
  ${RichTextStyle}
  position: relative;
  border-radius: 8px;
  line-height: 39px;
  display: ${props => (props.active ? 'block' : 'none')};
  ${px(3)}
  ${py(0)}
  transition: all 500ms ease-in-out 0s;
  font-weight: 500;
  ${breakpoint('mobile', 'tablet')`
    ${p(0)}
    font-size: 13vw;
    line-height: 24px;
  `}
`;
